var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-danger mb-5"},[_vm._v(" "+_vm._s(_vm.$t("dataStructures.isLockedHint"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }